import React from 'react';
import lodashEscape from 'lodash/escape';
import kebabCase from 'lodash/kebabCase';

const CodeBlock = ({ language, code, intro, sectionId, bolded = false, personal = false }: any) => (
  <div id={sectionId && `section-${sectionId}`}>
    {intro && intro !== '' && (
      <div
        className="prose-xl prose-primary py-2"
        dangerouslySetInnerHTML={{ __html: intro.trim() }}
      />
    )}
    {bolded && bolded !== '' && (
      <div
        className="prose-xl prose-primary font-bold py-2"
        dangerouslySetInnerHTML={{ __html: bolded.trim() }}
      />
    )}
    {personal && personal !== '' && (
      <div
        className="prose-xl prose-primary py-2"
        dangerouslySetInnerHTML={{ __html: personal.trim() }}
      />
    )}

    {code && code !== '' && (
      <div className="gatsby-highlight" data-language={language}>
        <pre className={`language-${language}`}>
          <code
            className={`language-${language}`}
            dangerouslySetInnerHTML={{
              __html: lodashEscape(code.trim()),
            }}
          />
        </pre>
      </div>
    )}
  </div>
);

CodeBlock.generateKey = ({ code, intro }: any) => {
  if (intro && intro !== '') {
    return `key-${kebabCase(intro)}`;
  }

  return `key-${kebabCase(code)}`;
};

export default CodeBlock;
